import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PayrollDeduction } from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayrollDeductionService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/Contractors/me/payroll-deductions';

  getByYear(year?: number): Observable<PayrollDeduction[]> {
    const params = HttpHelper.toHttpParams(year != null ? { year } : {});
    return this.http.get<PayrollDeduction[]>(this.apiUrl, { params });
  }

  downloadReceipt(id: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/receipt`, { responseType: 'blob' });
  }
}
